import ddt from '@wix/da-ddt';

const logger = ddt.createLogger('comments');
export default logger;
